export default "__VITE_ASSET__ByTTqpmf__";